<template>
    <DisplayTextWithRoute
        :value="value"
        routename="eventinfo"
        :eventId="row.Station?.EventID"
    />
</template>
<script lang="ts" setup>
import { DisplayTextWithRoute } from '@/components';
import type { StationDeviceStatus } from '@/objects/generated';

defineProps<{
    value: string;
    row: StationDeviceStatus;
}>();
</script>
